/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Status_Cleaning_UpInputs */



/**
* | output |
* | --- |
* | "Cleaning Up" |
*
* @param {Iconik_Publish_Status_Cleaning_UpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_status_cleaning_up = /** @type {((inputs?: Iconik_Publish_Status_Cleaning_UpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Status_Cleaning_UpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nettoyage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aufräumen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pulizia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Уборка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Limpieza")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("清理")
	if (locale === "ja") return /** @type {LocalizedString} */ ("クリーンアップ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सफाई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Limpeza")
	return /** @type {LocalizedString} */ ("Cleaning Up")
});